<nz-card class="monitoring">
  <h4 class="primary-color mb-0">Monitoraggio</h4>
  <ng-container *ngIf="!isEdit">
    <hr class="mt-3" />
    <div
      *ngIf="
        monitoringClientChartData && monitoringClientChartData;
        else loading
      ">
      <div class="d-flex gap-3 justify-content-between mb-4">
        <div class="d-flex justify-content-center align-items-center gap-2">
          <button
            (click)="changeTab('team')"
            class="choice-btn btn rounded-pill d-flex align-items-center px-2 py-1 primary-color">
            <mat-icon *ngIf="selectedTab === 'team'" class="me-1 small-icon"
              >done</mat-icon
            >
            Team
            <span class="badge bg-light text-dark ms-2">
              {{ velocityTeam }}
            </span>
          </button>

          <button
            (click)="changeTab('client')"
            class="choice-btn client btn rounded-pill d-flex align-items-center px-2 py-1 primary-color">
            <mat-icon *ngIf="selectedTab === 'client'" class="me-1 small-icon"
              >done</mat-icon
            >
            Cliente
            <span class="badge bg-light text-dark ms-2">
              {{ velocityClient }}
            </span>
          </button>
        </div>

        <!-- COMMENTO TEMPORANEO -->
        <!-- <div class="d-flex gap-3 justify-content-end align-items-center">
          <div class="d-flex align-items-center gap-1">
            <span class="fw-bold">Data inizio</span>
            <nz-date-picker
              nzFormat="dd/MM/yyyy"
              [(ngModel)]="startDate"
              [nzDisabledDate]="configureValideRangeForStartDate"
            ></nz-date-picker>
          </div>

          <div class="d-flex align-items-center gap-1">
            <span class="fw-bold">Data fine</span>
            <nz-date-picker
              nzFormat="dd/MM/yyyy"
              [(ngModel)]="endDate"
              [nzDisabledDate]="configureValideRangeForEndDate"
            ></nz-date-picker>
          </div>
        </div> -->
      </div>

      <div class="">
        <div
          class="soft-skills_chart w-100 align-self-center flex-grow-1"
          *ngIf="selectedTab === 'team'">
          <app-generic-chart-widget
            [chartId]="'chart-monitoring'"
            [chartData]="monitoringTeamChartData"
            [chartType]="chartType"
            [chartOptions]="getChartOptions()"></app-generic-chart-widget>
        </div>

        <div
          class="soft-skills_chart w-100 align-self-center flex-grow-1"
          *ngIf="selectedTab === 'client'">
          <app-generic-chart-widget
            [chartId]="'chart-monitoring-client'"
            [chartData]="monitoringClientChartData"
            [chartType]="chartType"
            [chartOptions]="getChartOptions()"></app-generic-chart-widget>
        </div>
      </div>
    </div>

    <ng-template #loading>
      <nz-skeleton [nzActive]="true" [nzParagraph]="{ rows: 15 }"></nz-skeleton>
    </ng-template>
  </ng-container>
</nz-card>
